import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import {
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
} from 'reactstrap';
import NavItems from './NavItem';
import styles from './Sidebar.module.scss';
import classNames from 'classnames';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
export const SidebarComponent = ({ logo }) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleSidebarCollapse = () => {
    setIsSidebarCollapsed((prev) => {
      const newValue = !prev;
      document.getElementById('main_portal_target').style.marginLeft = newValue
        ? '75px'
        : '250px';
      document.getElementById('sidenav-main').style.maxWidth = newValue
        ? '75px'
        : '250px';

      return newValue;
    });
  };
  const toggleCollapse = () => {
    setCollapseOpen((prev) => !prev);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: '_blank',
    };
  }
  return (
    <Navbar
      className={classNames(
        styles.sidebar,
        'navbar-vertical fixed-left navbar-light'
      )}
      expand="md"
      id="sidenav-main"
      style={{ transition: 'max-width 0.3s ease' }}
    >
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {logo ? (
          <NavbarBrand
            className={styles.sidebarLogoContainer}
            {...navbarBrandProps}
          >
            {!isSidebarCollapsed && (
              <img
                style={{ maxWidth: '150px' }}
                src={logo.imgSrc}
                alt={logo.imgAlt}
                className={styles.imgSrc}
              />
            )}
            <SvgIcon
              src={SvgIconSrc.sidebarCollapse}
              className={styles.sidebarCollapseIcon}
              onClick={handleSidebarCollapse}
              rotate={isSidebarCollapsed ? '180' : '0'}
            />
          </NavbarBrand>
        ) : null}
        {!isSidebarCollapsed && (
          <Collapse navbar isOpen={collapseOpen}>
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <NavItems closeCollapse={closeCollapse} />
          </Collapse>
        )}
      </Container>
    </Navbar>
  );
};

SidebarComponent.propTypes = {
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};
